import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { Observable } from 'rxjs';

import { PaginationParams } from '@core/api/api-entity.service';
import { DdqGpInvitation, DdqInviteeRow, DdqLpInvitation } from '@core/models/ddq-invitation.model';
import { DdqInvitationState, DdqInvitationStore } from './ddq-invitation.store';

@Injectable({ providedIn: 'root' })
export class DdqInvitationQuery extends Query<DdqInvitationState> {
  constructor(protected store: DdqInvitationStore) {
    super(store);
  }

  selectGpInvitations(): Observable<DdqGpInvitation[]> {
    return this.select((state) => state.gpInvitations);
  }

  selectLpInvitations(): Observable<DdqLpInvitation[]> {
    return this.select((state) => state.lpInvitations);
  }

  selectGpPagination(): Observable<PaginationParams | null> {
    return this.select((state) => state.gpPagination);
  }

  selectLpPagination(): Observable<PaginationParams | null> {
    return this.select((state) => state.lpPagination);
  }

  selectLoading(): Observable<boolean> {
    return this.select((state) => state.loading);
  }

  selectError(): Observable<string | null> {
    return this.select((state) => state.error);
  }

  selectInviteeRows(): Observable<DdqInviteeRow[]> {
    return this.select((state) => state.inviteeRows);
  }

  selectInviteePagination(): Observable<PaginationParams | null> {
    return this.select((state) => state.inviteePagination);
  }

  selectHasInvitees(): Observable<boolean | null> {
    return this.select((state) => state.hasInvitees);
  }
}
